import {register} from '../vendor/theme-scripts/theme-sections';
import {popoutSection} from '../features/popout';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import fadeIn from '../util/fade-in';
import tabs from '../features/tabs';
import {QuickAddProduct} from '../features/quick-add-product';
import {makeGridSwatches} from '../features/swatch';
import {Siblings} from '../features/siblings';
import {Slider} from '../features/slider';

const selectors = {
  relatedSectionElem: '[data-related-section]',
  relatedProduct: '[data-product-grid-item]',
  recentlyViewed: '[data-recent-wrapper]',
  recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  recentlyProduct: '#recently-viewed-products',
  productItem: '.product-item',
  slider: '[data-slider]',
};

const attributes = {
  limit: 'data-limit',
  minimum: 'data-minimum',
  productId: 'data-product-id',
};

const classes = {
  isHidden: 'is-hidden',
};

class Related {
  constructor(section) {
    this.section = section;
    this.sectionId = section.id;
    this.container = section.container;

    this.init();
    this.recent();
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.relatedSectionElem);

    if (!relatedSection) {
      return;
    }

    const self = this;
    const productId = relatedSection.getAttribute(attributes.productId);
    const limit = relatedSection.getAttribute(attributes.limit);
    const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.relatedSectionElem);

        if (inner.querySelector(selectors.relatedProduct)) {
          const innerHtml = inner.innerHTML;
          hideElement(relatedSection);
          relatedSection.innerHTML = innerHtml;
          slideDown(relatedSection);

          const relatedProducts = relatedSection.querySelectorAll(selectors.relatedProduct);

          makeGridSwatches(self.section);

          // Init Siblings
          new Siblings(self.section);

          if (relatedProducts.length > 4 && relatedSection.querySelector(selectors.slider)) {
            new Slider(relatedSection);
          }
        } else {
          relatedSection.dispatchEvent(
            new CustomEvent('theme:tab:hide', {
              bubbles: true,
            })
          );
        }
      })
      .catch(function () {
        relatedSection.dispatchEvent(
          new CustomEvent('theme:tab:hide', {
            bubbles: true,
          })
        );
      });
  }

  recent() {
    const recentlyViewed = this.container.querySelector(selectors.recentlyViewed);
    const howManyToshow = recentlyViewed ? parseInt(recentlyViewed.getAttribute(attributes.limit)) : 4;

    Shopify.Products.showRecentlyViewed({
      howManyToShow: howManyToshow,
      wrapperId: `recently-viewed-products-${this.sectionId}`,
      section: this.section,
      onComplete: (wrapper, section) => {
        const container = section.container;
        const recentlyViewedHolder = container.querySelector(selectors.recentlyViewed);
        const recentlyViewedWrapper = container.querySelector(selectors.recentlyViewedWrapper);
        const recentProducts = wrapper.querySelectorAll(selectors.productItem);
        const minimumNumberProducts = recentlyViewedHolder.hasAttribute(attributes.minimum) ? parseInt(recentlyViewedHolder.getAttribute(attributes.minimum)) : 4;
        const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
        const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

        if (checkRecentInRelated || checkRecentOutsideRelated) {
          if (checkRecentOutsideRelated) {
            recentlyViewedWrapper.classList.remove(classes.isHidden);
          }

          fadeIn(recentlyViewedHolder);

          recentlyViewedHolder.dispatchEvent(
            new CustomEvent('theme:tab:check', {
              bubbles: true,
            })
          );

          makeGridSwatches(section);

          // Init Siblings
          new Siblings(section);

          if (recentProducts.length > 4 && recentlyViewedHolder.querySelector(selectors.slider)) {
            new Slider(recentlyViewedHolder);
          }
        }
      },
    });
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);
  },
};

register('related', [relatedSection, popoutSection, tabs]);

if (!customElements.get('quick-add-product')) {
  customElements.define('quick-add-product', QuickAddProduct);
}
